import { retryWhen } from 'rxjs';
import { ProductPosition } from './productPosition';

export namespace Products {

  export interface ISubProductNew {
    op_sub_code: string;
    osp_code: string;
    osp_description: string;
    osp_qty_picked: number;
    osp_stock: string;
    osp_volume: string;
    osp_weigth: string;
    qty_needed: number;
  }

  export interface IProductNew {
    op_code: string;
    op_description: string;
    op_qta_ordered: string;
    op_qta: any;
    op_weigth: number;
    or_note?: string;
    op_stock: number;
    op_positions: ProductPosition.IPositionInOrder[];
    //not ok in interface must be moved in implementation class
    op_stockQTA?: string;
    tab_order_status_cod: any;
    sub_products?: Products.SubProducts[];
  }

  export interface IProductToSend extends IProductNew {
    op_note: string;

    op_checked: boolean;
    //From APP
    op_qta_picked: number;

    orQtaNeeded?: number;
  }

  export interface IProduct extends Omit<IProductToSend, 'op_checked'> {
    products_order_id: number;
    op_checked: boolean;
    op_qta: number;
    op_qta_picked: number;
  }

  // export interface IProductToSend extends IProductNew {
  //   op_note: string;
  //   op_checked: boolean;
  //   orQtaNeeded: number; //StrutoCamila
  // }

  export interface IPositionInOrder {
    op_full_position: string;
  }

  export interface IProductUpdate {
    barcodes: Products.Barcodes[];
    product_id: number;

    op_description?: string;
    op_checked: boolean;
    op_qta_picked: number;
    op_qta?: number;

    //NotFromServer
    desiredQuantity?: number;
    minQuantity?: number;
    subProducts?: SubProducts[];
    sub_products?: SubProducts[];
    orQtaNeeded?: number;
  }

  export interface IsubProducts {
    osp_checked: boolean;
    osp_code: string;
    osp_description: string;
    osp_note: string;
    osp_position: string;
    osp_qty: number;
    osp_qty_ordered?: number;
    osp_qty_picked: number;
    osp_sub_pr_id: number;
    osp_weigth: number;
    qty_needed?: number;
    barcodes?: Barcodes[];
  }

  export class SubProducts implements IsubProducts {
    osp_checked: boolean = false;
    osp_code: string = '';
    osp_description: string = '';
    osp_note: string = '';
    osp_position: string = '';
    osp_qty: number = 0;
    osp_qty_ordered?: number = 0;
    osp_qty_picked: number = 0;
    osp_sub_pr_id: number = 0;
    osp_weigth: number = 0;
    interChangeValue: number = 0;
    qty_needed?: number = 0;
    barcodes?: Barcodes[] = [];

    //notfromserver
    opCheckedOnAssegna?: boolean = false;
    minimumPerProduct?: number = 0;

    constructor(subProd: IsubProducts | null) {
      if (!subProd) return;
      this.osp_checked = subProd.osp_checked;
      this.osp_code = subProd.osp_code;
      this.osp_description = subProd.osp_description;
      this.osp_note = subProd.osp_note;
      this.osp_position = subProd.osp_position;
      this.osp_qty = subProd.osp_qty;
      this.osp_qty_ordered = subProd.osp_qty_ordered;
      this.osp_qty_picked = subProd.osp_qty_picked;
      this.osp_sub_pr_id = subProd.osp_sub_pr_id;
      this.osp_weigth = subProd.osp_weigth;
      this.qty_needed = subProd?.qty_needed;
      this.barcodes = subProd?.barcodes;
    }
  }

  export interface IProductSimilar {
    pr_code: string;
    pr_description: string;
  }

  export class ProductSimilar implements IProductSimilar {
    pr_code: string;
    pr_description: string;
    //from app
    pr_checked: boolean = false;
  }

  export class Barcodes {
    barcode_id: number;
    barcode_text: string;
    box_id: number;
    lot: number;
    progressive: number;
    scanned_date: string = new Date().toISOString();
  }

  export class Product implements IProduct {
    op_qta_picked: number;
    op_positions: ProductPosition.IPositionInOrder[];
    op_checked: boolean = false;
    op_code: string;
    op_description: string;
    op_qta: number;
    op_qta_ordered: string;

    op_weigth: number;
    products_order_id: number;
    op_note: string;
    op_stock: any;
    op_qta_stock?: string;
    indexNo?: number;
    pr_code?: string;
    full_position?: ProductPosition.Position;

    // not from server
    barcodes?: Barcodes[];
    op_stockQTA?: string;
    tab_order_status_cod: any;
    sub_products?: SubProducts[] = [];

    isLabel?: boolean = false;
  }

  export class ProductToAdd {
    order_id!: number;
    op_code!: string;
    op_description!: string;
    op_remaining_qty!: string;
    op_qty!: number;
    op_weight!: number;
    op_position!: any;
    op_note!: string;
    op_checked?: boolean;

    constructor(product: ProductSimilar) {
      this.op_description = product.pr_description;
      this.op_code = product.pr_code;
    }

    existingProduct?(item: Product) {
      this.op_remaining_qty =
        item.op_qta_ordered?.length > 0
          ? item.op_qta_ordered
          : `${item.op_qta}`;
      this.op_qty = item.op_qta;
      this.op_note = item.op_note;
    }

    addedProduct?(item: any) {
      this.op_weight = item.op_weigth;
      this.op_position = null;
    }
  }

  export interface StockProducts {
    category_id: number;
    type: string;
    head_family: string;
    sub_family: string;
    head_group: string;
    sub_group: string;
    description: string;
    pr_stock: number;
    committed: number;
    available: number;
  }

  export interface IProductDetail {
    family_desc: string;
    sub_family_desc: string;
    group_desc: string;
    sub_group_desc: string;
    pr_code: string;
    pr_description: string;
    pr_stock: number;
    committed: number;
    available: number;
  }

  export interface IProductDetails {
    products_order_id?: string;
    product_id: string;
    product_position_id: string;
    family_desc: string;
    sub_family_desc: string;
    group_desc: string;
    sub_group_desc: string;
    pr_code: string;
    pr_b64_image: string;
    pr_b64_position_image: string;
    pr_description: string;
    pr_stock: number;
    pr_weight: number;
    pr_volume: string;
    pr_price: number;
    pr_positions: IProductPosition[];
    pr_qty: number;
    committed?: any;
    available?: any;
    sub_products?: SubProducts[];
  }

  export class ProductDetails implements IProductDetails {
    products_order_id?: string;
    product_id: string;
    product_position_id: string;
    family_desc: string;
    sub_family_desc: string;
    group_desc: string;
    sub_group_desc: string;
    pr_code: string;
    pr_b64_image: string;
    pr_b64_position_image: string;
    pr_description: string;
    pr_stock: number;
    pr_weight: number;
    pr_volume: string;
    pr_price: number;
    pr_positions: IProductPosition[];
    pr_qty: number;
    committed?: any;
    available?: any;
    sub_products?: SubProducts[];
    constructor(productDetail: IProductDetails) {
      if (!productDetail) return;
      Object.assign(this, productDetail);
    }
  }

  export interface IProductPosition {
    product_position_id: string;
    product_id: string;
    pr_description: string;
    pr_code: string;
    // pr_b64_image?: string;
    pr_b64_image_position?: string;
    pr_b64_position_image?: string;
    pr_image_position?: string;
    pr_lane: string;
    pr_shelf: string;
    pr_position: string;
    pr_qty: number;
  }
  
}

export interface NewProduct {
  op_code: string;
  op_description: '0';
  op_qta: '0';
  op_weight: '0';
  op_stock: '0';
  op_positions: {
    op_full_positon: string;
  };
}

export interface SaveProducts {
  product_id: number;
  pr_code: string;
  pr_description: string;
  pr_b64_image: string;
  pr_b64_position_image: string;
}

export interface ProductImage {
  product_id: string;
  pr_b64_image?: string;
  pr_b64_position_image?: string;
}
